import { useTranslation } from 'libs/i18n';
import { DocumentsTableFeature } from 'modules/client/common/feature';

export const CompanyConfirmStructureSection = () => {
  const { t } = useTranslation();

  return (
    <DocumentsTableFeature
      name="confirmStructure.files"
      title={t('client.legal.companyConfirmStructure.title')}
      titleVariant="subtitle"
    />
  );
};
